import React, { useEffect, useState } from 'react';
import "./NavForm.css"

// Pictures
import logoFullGold from "../../img/2025_GetuppLogo_full_gold.png";
import logo from "../../img/2025_GetuppLogo_Full white.png";
import { Link } from 'react-router-dom';

function NavForm({logoType}) {
    const [show, handleShow] = useState(false);
    const transitionNavBar = () => {
        if (window.scrollY > 100) {
            handleShow(true);
        } else {
            handleShow(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", transitionNavBar);
        return () => window.removeEventListener("scroll", transitionNavBar);
    }, []);

    
    return (
        <div>
            <div className={`navForm ${show && "navFormWhite"}`}>
                    <Link to='/'>
                        <img className="navFormLogo" src={logoType === "gold" ? logoFullGold : logo} alt=""/>
                    </Link>
                </div>
        </div>
    )
}

export default NavForm

